import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Panel,
  Icon,
  Form,
  Row,
  Col,
  Grid,
  Button,
  FormGroup,
  Input,
  ControlLabel,
  Message,
} from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { isEmpty } from 'lodash-es'
import classNames from 'classnames'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import ExpertListTable from '../../components/table/expertListTable/ExpertListTable'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveApproveExpert } from '../../redux/actions/approveExpert'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import ConfirmWidget from '../confirm/ConfirmWidget'
import './styles.less'

export default function ApproveExpertWidget({ schema, onUpdateSchema }) {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const dispatch = useDispatch()
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors, watch } =
    useForm()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveApproveExpert = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      const _schema = await saveApproveExpert(request)
      if(_schema.success){
        onUpdateSchema()
        await dispatch(getSchemaSidebar(projectId))
      }else{
        setErrorMessage(e.response.data.errorMessage || 'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    } catch (e) {
      setErrorMessage(e.response.data.errorMessage || 'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const [formSchema, setFormSchema] = useState(schema)

  const _expertData = !isEmpty(schema.itemsList)
    ? schema.itemsList.map((item) => {
        return {
          ...item,
          isSelected: true,
        }
      })
    : []
  const [selectedExpert, setSelectedExpert] = useState(_expertData)

  const handleOnClickSelectExpert = (value, checked, rowData) => {
    setSelectedExpert((state) => {
      return state.map((item) => {
        if (item.id === rowData.id) {
          return {
            ...item,
            isSelected: checked,
          }
        }
        return item
      })
    })
  }

  const onSubmit = (data) => {
    if (isEmpty(selectedExpert)) {
      return setErrorMessage('กรุณาเลือกผู้ทรงคุณวุฒิ')
    }

    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = (data) => {
    const request = {
      projectVersionId: projectId,
      remark: data.remark,
      itemsList: selectedExpert,
    }

    setIsShowConfimModal(false)
    handleSaveApproveExpert(request)
  }

  const isAllUnapproveExpert = (_selectedExpert) => {
    if (isEmpty(_selectedExpert)) {
      return true
    }
    const selectedApproveExpert = _selectedExpert.filter((item) => item.isSelected === true)
    if (selectedApproveExpert.length === 0) {
      return true
    }
    return false
  }

  const renderApproveExpertList = (_selectedExpert) => {
    const approveExpertList = _selectedExpert.filter((item) => item.isSelected === true)
    const notApproveExpertList = _selectedExpert.filter((item) => item.isSelected != true)

    return (
      <>
        <div style={{ height: 550, minHeight: 550, overflowY: 'scroll' }}>
          <p style={{ color: 'limegreen' }}>
            <b>รายการผู้ทรงฯ ที่อนุมัติ</b>{' '}
            <Icon size="lg" appearance="ghost" icon="check-circle" />
          </p>

          {approveExpertList?.length < 1 && (
            <p style={{ marginLeft: 10 }}>
              <i> - ไม่มีผู้ทรงฯที่อนุมัติ</i>
            </p>
          )}

          {approveExpertList.map((item) => (
            <p key={item.id} style={{ marginLeft: 10 }}>
              - {item.name} {item.isOnline && <span>{'(online)'}</span>}
            </p>
          ))}
          <br />

          <p style={{ color: 'orange' }}>
            <b>รายการผู้ทรงฯ ที่ไม่อนุมัติ</b>{' '}
            <Icon size="lg" appearance="ghost" icon="times-circle" />
          </p>

          {notApproveExpertList?.length < 1 && (
            <p style={{ marginLeft: 10 }}>
              <i> - ไม่มีผู้ทรงฯที่ไม่อนุมัติ</i>
            </p>
          )}

          {notApproveExpertList.map((item) => (
            <p key={item.id} style={{ marginLeft: 10 }}>
              - {item.name} {item.isOnline && <span>{'(online)'}</span>}
            </p>
          ))}
        </div>
      </>
    )
  }

  return (
    <>
      <Form fluid className="approve-expert-widget">
        <Panel shaded header="" bordered collapsible defaultExpanded>
          <Grid fluid>
            <Row>
              <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <h6 className="header">{formSchema.budgetInfo?.header}</h6>
              </Col>
              <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <span>{`${formSchema.budgetInfo?.budget.toLocaleString()} บาท`}</span>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Message
                  showIcon
                  type="warning"
                  description={`ต้องการผู้ทรงคุณวุฒิ${formSchema.conditionOfReviewer?.conditionDesc}`}
                />
                {/* <span>{`${formSchema.minimumLabel} ${formSchema.minimumExpert} คน`}</span> */}
              </Col>
            </Row>
            <Row>
              <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <ExpertListTable
                  data={formSchema.itemsList}
                  isEditable
                  isDisableOnline
                  selectedExpert={selectedExpert}
                  onClickSelect={handleOnClickSelectExpert}
                  isHideWorkload
                />
              </Col>
              {formSchema.itemsList.length > 0 && 
              <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={12} lg={12}>
                <FormGroup>
                  <ControlLabel
                    className={classNames(isRequired(formSchema.remark?.validators) && 'required')}
                  >
                    {formSchema.remark?.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.remark} />
                  <Input
                    name={formSchema.remark?.name}
                    defaultValue={formSchema.remark?.value || ''}
                    componentClass="textarea"
                    placeholder={formSchema.remark?.label}
                    inputRef={register(isValidators(formSchema.remark?.validators))}
                  />
                </FormGroup>
              </Col>}

              <Col xs={24} sm={24} md={24} lg={24}>
                {!!errorMessage && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message showIcon type="error" description={errorMessage} />
                  </Row>
                )}
              </Col>
              {formSchema.itemsList.length > 0 && 
              <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
                <Button
                  style={{ width: 160 }}
                  // appearance="ghost"
                  color="rgb(45, 168, 136)"
                  appearance="primary"
                  onClick={handleSubmit(onSubmit)}
                  icon={<Icon appearance="ghost" icon="edit" />}
                  disabled={isLoading}
                >
                  {'อนุมัติผู้ทรงคุณวุฒิ'}
                  {/* {formSchema.buttonApproveExpertLabel} */}
                </Button>
              </Col>}
            </Row>
          </Grid>
        </Panel>
        <ConfirmWidget
          size="sm"
          title={<p style={{ lineHeight: 2 }}>ยืนยันการอนุมัติผู้ทรงคุณวุฒิ</p>}
          show={isShowConfimModal}
          detail={renderApproveExpertList(selectedExpert)}
          onCancle={() => setIsShowConfimModal(false)}
          onConfirm={handleSubmit(handleOnConfirmModal)}
        />
      </Form>
    </>
  )
}

// const expertData = [
//   {
//     id: '63-0001',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     name: 'รศ.ดร. กนก รัตนะกนกชัย',
//     status: 'ด้านวิชาการ',
//     group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 1',
//     date: 'เวอร์ชั่น 1.01 19 พ.ย. 2563 07:57 น.',
//     stars: 820,
//     year: 2563,
//     isOnline: true,
//   },
//   {
//     id: '63-0002',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     name: 'ดร. กนกกาญจน์ พรหมน้อย',
//     status: 'ด้านพิธีการ',
//     group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 1200,
//     year: 2563,
//     isOnline: false,
//   },
//   {
//     id: '63-0003',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     name: 'ผศ.พญ. กนกพร ภิญโญพรพาณิชย์',
//     status: 'ด้านการจัดการ/กระบวนการ ',
//     group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 3',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 610,
//     year: 2563,
//     isOnline: true,
//   },
//   {
//     id: '63-0004',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     name: 'รองศาตราจารย์ ดร. กนกพร สังขรักษ์',
//     status: 'ด้านสื่อสาร',
//     group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 4',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 5322,
//     year: 2563,
//     isOnline: false,
//   },
//   {
//     id: '63-0005',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     name: 'ผศ.ดร. กนกพร สุคำวัง',
//     status: 'ด้านสันทนาการ',
//     group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 5',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 852,
//     year: 2563,
//     isOnline: true,
//   },
//   {
//     id: '63-0006',
//     avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
//     name: 'อ.ดร. กนกวรรณ ปัญจะมา',
//     status: 'ด้านวิทยาการ',
//     group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 6',
//     date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
//     stars: 3209,
//     year: 2563,
//     isOnline: false,
//   },
// ]
